type SectionHeadingProps = {
  title: string;
  subtitle?: string;
  id?: string;
  hideSeparators?: boolean;
};

export const SectionHeading = ({
  title,
  subtitle,
  id,
  hideSeparators = false,
}: SectionHeadingProps) => (
  <>
    <div className='text-text relative flex items-center justify-center'>
      {!hideSeparators && <div className='hidden flex-1 border-t border-gray-500 md:block' />}
      <h2 className='px-5 text-center text-2xl font-bold' id={id}>
        {title}
      </h2>
      {!hideSeparators && <div className='hidden flex-1 border-t border-gray-500 md:block' />}
    </div>

    {subtitle ? <h3 className='text-text-muted text-center text-lg'>{subtitle}</h3> : null}
  </>
);
